
// components/common/CustomSelect.jsx
import React from "react";
import "../../styles/custom-select.css"

function CustomSelect({ options, value, onChange, placeholder = "-- Seleccionar --" }) {
  const normalizedOptions = options.map((option) => {
    if (typeof option === "string") {
      return { label: option, value: option };
    }
    return { label: option.label, value: option.value };
  });

  return (
    <div className="custom-select-wrapper">
      <select className="custom-select" value={value} onChange={(e) => onChange(e.target.value)}>
        <option value="" disabled>
          {placeholder}
        </option>
        {normalizedOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
}

export default CustomSelect;